'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 650px;\n  max-width: calc(90vw - 10px);\n  padding: 5px;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  box-shadow: 5px 5px 5px gray;\n'], ['\n  width: 650px;\n  max-width: calc(90vw - 10px);\n  padding: 5px;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  box-shadow: 5px 5px 5px gray;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n'], ['\n  width: 25%;\n  @media (max-width: 1024px) {\n    width: 33.33%;\n  }\n  @media (max-width: 782px) {\n    width: 50%;\n  }\n  @media (max-width: 415px), (max-height: 415px) {\n    width: 100%;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  h1,h2,h2,h4, .paypal-button {\n    text-align: center;\n  }\n\n  li {\n    padding-bottom: 0.5rem;\n  }\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border: 1px solid rgba(0,0,0,.75);\n  border-radius: .25rem;\n  margin: 20px;\n  padding: 5px;\n  width: calc(25% - 52px);\n  box-shadow: 5px 5px 5px gray;\n  transform: none;\n\n  h1,h2,h2,h4, .paypal-button {\n    text-align: center;\n  }\n\n  li {\n    padding-bottom: 0.5rem;\n  }\n\n  img {\n    width: 100%;\n    height: auto;\n  }\n\n  &.grid-cols-2 {width: calc(50% - 52px);}\n  &.grid-cols-3 {width: calc(75% - 52px);}\n  &.grid-cols-4 {width: calc(100% - 52px);}\n\n  @media (max-width: 1024px) {\n    width: calc(33% - 52px);\n    &.grid-cols-2 {width: calc(66% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 782px) {\n    width: calc(50% - 52px);\n    &.grid-cols-2 {width: calc(50% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n\n  @media (max-width: 415px), (max-height: 415px) {\n    width: calc(100vw - 52px);\n    &.grid-cols-2 {width: calc(100% - 52px);}\n    &.grid-cols-3 {width: calc(100% - 52px);}\n    &.grid-cols-4 {width: calc(100% - 52px);}\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactResizeDetector = require('react-resize-detector');

var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);

var _reactMasonryComponent = require('react-masonry-component');

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _paypalButton = require('../paypal-button/paypal-button');

var _paypalButton2 = _interopRequireDefault(_paypalButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var Panel = _styledComponents2.default.div(_templateObject2);

var GridSizer = _styledComponents2.default.div(_templateObject3);
var Card = _styledComponents2.default.div(_templateObject4);

var Purchase = function (_Component) {
  _inherits(Purchase, _Component);

  function Purchase(props) {
    _classCallCheck(this, Purchase);

    var _this = _possibleConstructorReturn(this, (Purchase.__proto__ || Object.getPrototypeOf(Purchase)).call(this, props));

    _this.state = {
      width: 640,
      height: 480
    };
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleRequestLink = _this.handleRequestLink.bind(_this);
    return _this;
  }

  _createClass(Purchase, [{
    key: 'handleResize',
    value: function handleResize(newWidth) {
      var width = newWidth < 640 ? newWidth : 640;
      var height = width / 16 * 9;
      this.setState({ width: width, height: height });
    }
  }, {
    key: 'handleRequestLink',
    value: function handleRequestLink(event) {
      var _this2 = this;

      event.preventDefault();
      var email = window.prompt("Please enter your email address:");
      if (window.vexpo && window.vexpo.firebase) {
        // Send the user a login link
        var actionCodeSettings = {
          url: window.location.protocol + '//' + window.location.host + '/#/lobby',
          handleCodeInApp: true
        };
        window.vexpo.firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings).then(function () {
          window.localStorage.setItem('emailForSignIn', _this2.state.email);
          alert("Email sent");
        }).catch(function (err) {
          if (err.code === 'auth/invalid-email') {
            alert('That does not appear to be a valid email address.  Please try again.');
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var groups = [];
      for (var category in this.props.beneficiaries) {
        groups.push(_react2.default.createElement(
          'div',
          { key: category },
          _react2.default.createElement(
            'h4',
            null,
            category
          ),
          _react2.default.createElement(
            'ul',
            null,
            this.props.beneficiaries[category].map(function (org) {
              return _react2.default.createElement(
                'li',
                { key: org },
                org
              );
            })
          )
        ));
      }
      var deals = this.props.deals.map(function (deal) {
        return _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'b',
            null,
            deal.brand
          ),
          ' ',
          deal.terms
        );
      });
      return _react2.default.createElement(
        _reactMasonryComponent2.default,
        null,
        _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-2' },
          _react2.default.createElement('img', { src: this.props.image }),
          _react2.default.createElement(_paypalButton2.default, { expoName: this.props.name, expoID: this.props.expoID, showID: this.props.showID, size: 'medium' })
        ),
        _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-2' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, onResize: this.handleResize }),
            _react2.default.createElement(_reactPlayer2.default, { url: this.props.video, width: this.state.width, height: this.state.height })
          )
        ),
        _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-2' },
          _react2.default.createElement(
            'h2',
            null,
            'Already bought a Discount Coupon Package?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please use the link we emailed you to sign in into the show and retrieve your Discount Coupon package.  If you cannot find the email, you can ',
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.handleRequestLink },
              'request a new one'
            )
          )
        ),
        _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-2' },
          _react2.default.createElement(
            'h2',
            null,
            'Beneficiaries'
          ),
          groups
        ),
        _react2.default.createElement(
          Card,
          { className: 'grid-item grid-cols-2' },
          _react2.default.createElement(
            'h2',
            null,
            'Deals'
          ),
          _react2.default.createElement(
            'ul',
            null,
            deals
          )
        )
      );
      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          Panel,
          null,
          _react2.default.createElement(
            'h1',
            null,
            'Purchase a Discount Coupon Package'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, onResize: this.handleResize }),
            _react2.default.createElement(_reactPlayer2.default, { url: this.props.video, width: this.state.width, height: this.state.height })
          ),
          _react2.default.createElement(
            'p',
            null,
            'Purchase your Discount Coupon package using'
          ),
          _react2.default.createElement(_paypalButton2.default, { expoName: this.props.name, expoID: this.props.expoID, showID: this.props.showID, size: 'medium' }),
          _react2.default.createElement(
            'h2',
            null,
            'Already bought a Discount Coupon Package?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Please use the link we emailed you to sign in into the show and retrieve your Discount Coupon package.  If you cannot find the email, you can ',
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.handleRequestLink },
              'request a new one'
            )
          )
        )
      );
    }
  }]);

  return Purchase;
}(_react.Component);

exports.default = Purchase;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/gift-cards/purchase.js
// module id = 1368
// module chunks = 0